import { ThumbsUp, ThumbsDown } from 'lucide-react'

interface FeedbackItem {
  score: number
  tags: string[]
  comment: string
  at: string | null
  message_id: string
  run_id: string
}

interface ThreadFeedbackProps {
  feedbackItems: Array<FeedbackItem> | null
}

export function ThreadFeedback({ feedbackItems }: ThreadFeedbackProps) {
  if (!feedbackItems || feedbackItems.length === 0) {
    return null
  }

  return (
    <div className="mt-3 space-y-2">
      <div className="text-xs font-medium text-muted-foreground">Feedback:</div>
      {feedbackItems.map((feedback, index) => (
        <div key={index} className="flex items-start gap-2 text-sm">
          <div className="flex items-center gap-1 mt-0.5">
            {feedback.score === 1 ? (
              <ThumbsUp className="h-3.5 w-3.5 text-green-600 fill-green-600" />
            ) : feedback.score === 0 ? (
              <ThumbsDown className="h-3.5 w-3.5 text-red-600 fill-red-600" />
            ) : null}
          </div>
          <div className="flex-1">
            {feedback.tags && feedback.tags.length > 0 && (
              <div className="flex flex-wrap gap-1 mb-1">
                {feedback.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className="px-1.5 py-0.5 text-xs rounded bg-muted text-muted-foreground"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}
            {feedback.comment && (
              <p className="text-muted-foreground">{feedback.comment}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

